import { createSlice } from "@reduxjs/toolkit";

const initialFilters = {
  // Etapa del convenio: UNDER_REVIEW | IN_PROGRESS | FINISHED | SETTLED, o null
  // para no filtrar.
  status: null,
  // CONTRACT | AGREEMENT, o null.
  type: null,
  // Vigencia: "soon" (vence dentro de 30 días) | "expired" (ya venció) | null.
  // Lo activan las tarjetas y el aviso del tablero.
  expiry: null,
};

export const agreementSlice = createSlice({
  name: "agreement",
  initialState: {
    list: [],
    loading: false,
    filters: initialFilters,
    current: null,
  },
  reducers: {
    setAgreementLoading: (state, action) => {
      state.loading = !!action.payload;
    },
    setAgreementList: (state, action) => {
      state.list = action.payload || [];
      state.loading = false;
    },
    // Paginación con cursor: agrega la siguiente página, de-duplicando por code
    // (el id del documento).
    appendAgreementList: (state, action) => {
      const incoming = action.payload || [];
      if (!incoming.length) return;
      const seen = new Set(state.list.map((a) => a.code));
      for (const item of incoming) {
        if (!seen.has(item.code)) {
          state.list.push(item);
          seen.add(item.code);
        }
      }
    },
    // Tras crear o editar: reemplaza el convenio en la lista sin recargar la
    // página entera, o lo pone de primero si es nuevo.
    upsertAgreement: (state, action) => {
      const item = action.payload;
      if (!item || !item.code) return;
      const index = state.list.findIndex((a) => a.code === item.code);
      if (index >= 0) state.list[index] = { ...state.list[index], ...item };
      else state.list.unshift(item);
      if (state.current && state.current.code === item.code) {
        state.current = { ...state.current, ...item };
      }
    },
    removeAgreement: (state, action) => {
      const code = action.payload;
      state.list = state.list.filter((a) => a.code !== code);
      if (state.current && state.current.code === code) state.current = null;
    },
    setAgreementFilters: (state, action) => {
      state.filters = { ...state.filters, ...(action.payload || {}) };
    },
    resetAgreementFilters: (state) => {
      state.filters = initialFilters;
    },
    setCurrentAgreement: (state, action) => {
      state.current = action.payload || null;
    },
  },
});

export const {
  setAgreementLoading,
  setAgreementList,
  appendAgreementList,
  upsertAgreement,
  removeAgreement,
  setAgreementFilters,
  resetAgreementFilters,
  setCurrentAgreement,
} = agreementSlice.actions;

export default agreementSlice.reducer;
